import { Log, Level, Logger } from 'ng2-logger';
import ApiClient from './alms-api';
import { Notification } from '../components/notification/main';
import Translator from '../core/i18n';

let _apiClient: ApiClient;
const token: any = localStorage.getItem('access_token');
const T = Translator.create();
const _logger = Log.create('Polling-Service');

export class LearningOutcomesService {
    constructor() {
        _apiClient = new ApiClient();
    }

    public async RequestAddLearningOutcomesAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/learningoutcomes', params, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestAddCourseDependencyAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/learningoutcomes/course', params, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestAddLearningOutcomesForActAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/learningoutcomes/activity', params, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestAddLearningOutcomesForQuestionAsync(params: any) {
        return _apiClient.RequestAsync('POST', 'api/learningoutcomes/question', params, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }


    public async RequestGetLearningOutcomesAsync(params: any) {
        return _apiClient.RequestAsync('GET', `api/learningoutcomes/course/${params.courseId}?skip=0&take=30`, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }


    public async RequestDeleteLearningOutcomesAsync(params: any) {
        return _apiClient.RequestAsync('DELETE', `api/learningoutcomes/${params.learningOutcomeId}`, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestDeleteCourseDependencyAsync(params: any) {
        return _apiClient.RequestAsync('DELETE', 'api/learningoutcomes/course', params, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }

    public async RequestUpdateCourseAsync(params: any) {
        return _apiClient.RequestAsync('PUT', `api/learningoutcomes/${params.learningOutcomeId}`, params.learningOutcomeValue, token)
            .then((responseData: Response) => {
                return responseData;
            }).catch((responseData) => {
                return responseData;
            });
    }
}